import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import EmployeeBenefitEnrollment from './EmployeeBenefitEnrollment';
import EmployeeInsuranceNumber from './EmployeeInsuranceNumber';
import _ from 'lodash';

class EmployeeCoverage extends DomainObject {
  employeeBenefitEnrollments;
  employeeInsuranceNumbers;

  _relations = {
    employeeBenefitEnrollments: [EmployeeBenefitEnrollment],
    employeeInsuranceNumbers: [EmployeeInsuranceNumber]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      employeeBenefitEnrollments: observable,
      employeeInsuranceNumbers: observable,
      allBenefitClasses: computed
    });

    this.merge(other);
  }

  get allBenefitClasses() {
    return _.map(this.employeeBenefitEnrollments, e => e.benefitClass);
  }
}

export default EmployeeCoverage;
